const pt = {
    '/': {
        title: '{brand} | Apostas Esportivas, Cassino ao Vivo & Saques Instantâneos',
        description: 'Caça-níqueis, cassino ao vivo & apostas esportivas no {brand}. Cassino crypto com saques instantâneos, jogos comprovadamente justos & suporte 24/7.'
    },
    '/casino': {
        title: 'Cassino Online | Caça-Níqueis, Blackjack & Dealers ao Vivo | {brand}',
        description: 'Caça-níqueis, blackjack, roleta & dealers ao vivo no {brand}. Centenas de jogos, depósitos crypto rápidos & saques instantâneos disponíveis 24/7.'
    },
    '/sports': {
        title: 'Apostas Esportivas Online | Apostas Crypto & Odds | {brand}',
        description: 'Aposte em esportes no {brand}. Odds competitivas em futebol, basquete & mais. Apostas ao vivo, apostas crypto seguras & pagamentos rápidos.'
    },
    '/livecasino': {
        title: 'Cassino ao Vivo | Blackjack, Roleta & Dealers ao Vivo | {brand}',
        description: 'Blackjack, roleta & jogos de cassino ao vivo no {brand}. Dealers reais, streaming em HD & ampla seleção de mesas ao vivo disponíveis 24/7.'
    },
    '/slots': {
        title: 'Caça-Níqueis Online | Grande Variedade de Slots de Cassino | {brand}',
        description: 'Uma enorme coleção de caça-níqueis no {brand}. Máquinas clássicas, vídeo slots & progressivas, todas jogáveis com crypto.'
    }
};
export default pt;
